<div class="form-content-item">
  <div *ngIf="statAdherents && statGenerale">
    <div class="form-header-item">
      <div>
        <action-bar [showDownload]="true" (onDownload)="exportStatExcel()"></action-bar>
      </div>
    </div>
    <div>
      <div>
        <h3 class="title-margin-top">{{ 'stat_title_general' | translate }}</h3>
        <mat-card>
          <div class="stat-generale">
            <div>
              <div *ngIf="profileCode != 'ACD'">
                <p>{{ 'stat_seve_resources' | translate }}</p>
                <p>{{ 'stat_seve_resources_used' | translate }}</p>
                <p>{{ 'stat_seve_resources_usage' | translate }}</p>
                <p>{{ 'stat_avg_formulas_industry' | translate }}</p>
              </div>
              <p>{{ 'stat_total_eu' | translate }}</p>
              <p>{{ 'stat_total_acd' | translate }}</p>
              <p>{{ 'stat_total_aceu' | translate }}</p>
              <p>{{ 'stat_total_abe' | translate }}</p>
              <p>{{ 'stat_total_ai' | translate }}</p>
              <p>{{ 'stat_total_be' | translate }}</p>
              <p>{{ 'stat_total_ci' | translate }}</p>
              <p>{{ 'stat_total_profiles' | translate }}</p>
              <p>{{ 'stat_total_projects' | translate }}</p>
              <p>{{ 'stat_online_projects' | translate }}</p>
              <p>{{ 'stat_total_pdf' | translate }}</p>
              <p>{{ 'stat_total_members' | translate }}</p>
              <p>{{ 'stat_total_logins' | translate }}</p>
              <p>{{ 'stat_total_plants' | translate }}</p>
            </div>

            <div>
              <div *ngIf="profileCode != 'ACD'">
                <p>{{ statGenerale?.resources }}</p>
                <p>{{ statGenerale?.resourcesUsed }}</p>
                <p>{{ statGenerale?.resourcesUsage }}</p>
                <p>{{ statGenerale?.formulasByIndustry }}</p>
              </div>
              <p>{{ statGenerale?.euNumber }}</p>
              <p>{{ statGenerale?.acdNumber }}</p>
              <p>{{ statGenerale?.aceuNumber }}</p>
              <p>{{ statGenerale?.abeNumber }}</p>
              <p>{{ statGenerale?.aiNumber }}</p>
              <p>{{ statGenerale?.beNumber }}</p>
              <p>{{ statGenerale?.ciNumber }}</p>
              <p>{{ statGenerale?.usersNumber }}</p>
              <p>{{ statGenerale?.projectsNumber }}</p>
              <p>{{ statGenerale?.onlineProjectsNumber }}</p>
              <p>{{ statGenerale?.pdfTotalNumber }}</p>
              <p>{{ statGenerale?.adherantNumber }}</p>
              <p>{{ statGenerale?.loginNumber }}</p>
              <p>{{ statGenerale?.centralNumber }}</p>
            </div>
          </div>
        </mat-card>
      </div>

      <div>
        <h3 class="title-margin-top">{{ 'stat_title_usage' | translate }}</h3>
        <mat-card>
          <div class="row">
            <h5>{{ 'stat_projects_pdf_period' | translate }}</h5>
            <div class="col-2">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'stat_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="dateDebut" [(ngModel)]="startDate" />
                <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
                <mat-datepicker #dateDebut></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'stat_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="dateFin" [(ngModel)]="endDate" />
                <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
                <mat-datepicker #dateFin></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-3">
              <button mat-raised-button color="primary" (click)="exportUsageExcel()">{{ 'stat_btn_export_usage' | translate }}</button>
            </div>
          </div>

          <div class="row">
            <h5>{{ 'stat_ceu_usage' | translate }}</h5>
            <div class="col-2">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'stat_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="dateDebutCEU" [(ngModel)]="startDateCEU" />
                <mat-datepicker-toggle matSuffix [for]="dateDebutCEU"></mat-datepicker-toggle>
                <mat-datepicker #dateDebutCEU></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'stat_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="dateFinCEU" [(ngModel)]="endDateCEU" />
                <mat-datepicker-toggle matSuffix [for]="dateFinCEU"></mat-datepicker-toggle>
                <mat-datepicker #dateFinCEU></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-3" *ngIf="perimeters.length > 0">
              <mat-form-field>
                <mat-label>{{ 'common_field_perimeter' | translate }}</mat-label>
                <mat-select name="perimeter" multiple [(ngModel)]="selectedPerimeterIds">
                  <mat-option *ngFor="let item of perimeters" [value]="item.id">{{ item.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-3">
              <button mat-raised-button color="primary" (click)="exportSolutionsUsageExcel()">{{ 'stat_btn_export_solution_usage' | translate }}</button>
            </div>
          </div>

          <div class="row">
            <h5>{{ 'stat_export_members' | translate }}</h5>
            <div class="col-2">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'stat_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="dateDebutAdherent" [(ngModel)]="startDateAdherent" />
                <mat-datepicker-toggle matSuffix [for]="dateDebutAdherent"></mat-datepicker-toggle>
                <mat-datepicker #dateDebutAdherent></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'stat_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="dateFinAdherent" [(ngModel)]="endDateAdherent" />
                <mat-datepicker-toggle matSuffix [for]="dateFinAdherent"></mat-datepicker-toggle>
                <mat-datepicker #dateFinAdherent></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-3">
              <button mat-raised-button color="primary" (click)="exportAdherents()">{{ 'stat_btn_export_members' | translate }}</button>
            </div>
          </div>
        </mat-card>
      </div>

      <div>
        <h3 class="title-margin-top">{{ 'stat_title_import_export' | translate }}</h3>
        <mat-card>
          <div class="stat-import-export">
            <div>
              <h5>{{ 'stat_exports_title' | translate }}</h5>
              <p>{{ 'stat_export_buyers' | translate: { count: importExportStats?.nbExportBuyer } }}</p>
              <p>{{ 'stat_export_companies' | translate: { count: importExportStats?.nbExportCompany } }}</p>
              <p>{{ 'stat_export_no_solution' | translate: { count: importExportStats?.nbExportNoSolution } }}</p>
              <p>{{ 'stat_export_with_solution' | translate: { count: importExportStats?.nbExportWithSolution } }}</p>
            </div>

            <div>
              <h5>{{ 'stat_imports_title' | translate }}</h5>
              <p>{{ 'stat_import_buyers' | translate: { count: importExportStats?.nbImportBuyer } }}</p>
              <p>{{ 'stat_import_companies' | translate: { count: importExportStats?.nbImportCompany } }}</p>
              <p>{{ 'stat_import_no_solution' | translate: { count: importExportStats?.nbImportNoSolution } }}</p>
              <p>{{ 'stat_import_with_solution' | translate: { count: importExportStats?.nbImportWithSolution } }}</p>
            </div>
          </div>
        </mat-card>
      </div>

      <div>
        <h3 *ngIf="profileCode != 'ACD'; else elseBlockACDTitle" class="title-margin-top">{{ 'stat_title_general_by_member' | translate }}</h3>
        <ng-template #elseBlockACDTitle>
          <h3 class="title-margin-top">{{ 'stat_title_general_by_eu' | translate }}</h3>
        </ng-template>
        <mat-card>
          <div class="row">
            <div class="col-12">
              <div *ngIf="profileCode != 'ACD'; else elseBlockACD">
                <mat-table [dataSource]="statAdherents">
                  <ng-container matColumnDef="nomAdherents">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_member_name' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.nomAdherents }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="adherentStatus">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_member_status' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.adherentStatus }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalLogins">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_total_logins' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalLogins }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalAdherents">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_total_profiles' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalAdherents }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalACD">
                    <mat-header-cell *matHeaderCellDef> ACD </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalACD }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalACEU">
                    <mat-header-cell *matHeaderCellDef> ACEU </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalACEU }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalAI">
                    <mat-header-cell *matHeaderCellDef> AI </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalAI }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalABE">
                    <mat-header-cell *matHeaderCellDef> ABE </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalABE }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalCI">
                    <mat-header-cell *matHeaderCellDef> CI </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalCI }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalBE">
                    <mat-header-cell *matHeaderCellDef> BE </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalBE }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalProjet">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_projects' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalProjet }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalCentrale">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_plants' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalCentrale }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalPDF">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_pdf_generated' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalPDF }}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="statAdherentsColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: statAdherentsColumns"></mat-row>
                </mat-table>
              </div>
              <ng-template #elseBlockACD>
                <mat-table [dataSource]="statAdherents">
                  <ng-container matColumnDef="nomEU">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_eu' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.nomEU }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalLogins">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_total_logins' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalLogins }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalAdherents">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_total_profiles' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalAdherents }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalACD">
                    <mat-header-cell *matHeaderCellDef> ACD </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalACD }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalACEU">
                    <mat-header-cell *matHeaderCellDef> ACEU </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalACEU }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalAI">
                    <mat-header-cell *matHeaderCellDef> AI </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalAI }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalABE">
                    <mat-header-cell *matHeaderCellDef> ABE </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalABE }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalCI">
                    <mat-header-cell *matHeaderCellDef> CI </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalCI }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalBE">
                    <mat-header-cell *matHeaderCellDef> BE </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalBE }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalProjet">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_projects' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalProjet }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalCentrale">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_plants' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalCentrale }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="totalPDF">
                    <mat-header-cell *matHeaderCellDef> {{ 'stat_col_pdf_generated' | translate }} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      {{ element.totalPDF }}
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="statAdherentsColumnsACD"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: statAdherentsColumnsACD"></mat-row>
                </mat-table>
              </ng-template>
            </div>
          </div>
        </mat-card>
      </div>
      <div *ngIf="profileCode == 'ACD'">
        <h3 class="title-margin-top">{{ 'stat_title_user' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-12">
              <mat-table [dataSource]="statuserACD">
                <ng-container matColumnDef="userName">
                  <mat-header-cell *matHeaderCellDef> {{ 'common_field_name' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.userName }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="userFirstName">
                  <mat-header-cell *matHeaderCellDef> {{ 'common_field_name' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.userFirstName }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="email">
                  <mat-header-cell *matHeaderCellDef> {{ 'common_field_name' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.email }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="profilCode">
                  <mat-header-cell *matHeaderCellDef> {{ 'common_field_name' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.profilCode }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="statUserACDColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: statUserACDColumns"></mat-row>
              </mat-table>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
